import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Flex, HStack, Text, Tooltip } from '@chakra-ui/react';

import { CypressIds } from '../../../../../../constants/cypressIds';
import { Statuses } from '../../../../../../constants/statuses';
import { showModal } from '../../../../../../redux/modules/modal';
import colors from '../../../../../../styles/theme/foundation/colors';
import RequirementTemplateBlueprintType from '../../../../../../types/RequirementTemplateBlueprintType';
import { tryFormatDate } from '../../../../../../utils/dateUtil';
import SaveTemplateModal from '../../../SaveTemplateModal';

const RequirementTemplateBuilderHeaderRight = ({ blueprint }) => {
  const dispatch = useDispatch();
  const currentTemplate = useSelector(blueprint.selectCurrentRequirementTemplate);
  const publishedStatus = useSelector(blueprint.selectChangesPublishedStatus);

  const statusMessageMap = {
    [Statuses.General]: {
      message: `Last Published: ${tryFormatDate(currentTemplate.updatedAt, true, 'MM/DD/YYYY')}`,
      background: colors.gradient.primary,
      textColor: 'white'
    },
    [Statuses.Updating]: {
      message: 'Publishing Changes...',
      background: colors.gradient.primary,
      textColor: 'white'
    },
    [Statuses.Success]: {
      message: 'Changes Published!',
      background: colors.gradient.success,
      textColor: 'white'
    },
    [Statuses.Error]: {
      message: 'Oops, Something Went Wrong',
      background: colors.gradient.error,
      textColor: 'white'
    }
  };

  const saveTemplate = type => {
    dispatch(blueprint.listRequirementTemplateFolders());
    dispatch(showModal(
      () => <SaveTemplateModal blueprint={blueprint} type={type} />,
      {
        title: 'Template Details',
        size: 'lg'
      }
    ));
  };

  if (currentTemplate.publishedAt) {
    return (
      <Flex
        alignItems="center"
        background={statusMessageMap[publishedStatus].background}
        borderRadius="lg"
        height="40px"
        justifyContent="center"
        mb={4}
      >
        <Text
          color={statusMessageMap[publishedStatus].textColor}
          textStyle="bodyMd500"
        >
          {statusMessageMap[publishedStatus].message}
        </Text>
      </Flex>
    );
  }

  return (
    <Flex justifyContent="right" mb={4}>
      {!currentTemplate.publishedAt && (
      <HStack justify="flex-end" spacing={4} width="40%">
        <Button
          data-analytics-id="requirement-template-save-as-draft-button"
          minW="118px"
          size="md"
          variant="secondary"
          onClick={() => saveTemplate('draft')}
        >
          Save as Draft
        </Button>
        <Tooltip
          label={!currentTemplate?.requirementTemplateBlocks?.length
                && 'Template must include at least one policy, document, or language block to be published'}
        >
          <Box>
            <Button
              data-analytics-id="requirement-template-publish-template-button"
              data-cy={CypressIds.reqTemplatesPublishTemplateButton}
              isDisabled={!currentTemplate?.requirementTemplateBlocks?.length}
              minW="148px"
              ml={4}
              size="md"
              variant="gradientSuccess"
              onClick={() => saveTemplate('publish')}
            >
              Publish Template
            </Button>
          </Box>
        </Tooltip>
      </HStack>
      )}
    </Flex>
  );
};

RequirementTemplateBuilderHeaderRight.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default RequirementTemplateBuilderHeaderRight;
